import { Controller as BaseController } from '@hotwired/stimulus';

export default class Controller extends BaseController {
  static values = {
    notEvaluated: Array,
    preReaders: Array,
    beginners: Array,
    intermediary: Array,
    fluent: Array,
  };

  static targets = ['userContainer', 'studentCount'];

  connect() {
    this.selectedLevel = 'intermediary';

    // Initialize with default selection after a small delay to ensure DOM is ready
    setTimeout(() => {
      this.updateSelectedBadge();
      this.updateUserDisplay();
    }, 100);
  }

  selectBadge(event) {
    event.preventDefault();
    const badge = event.currentTarget;
    const level = badge.dataset.level;

    if (level !== this.selectedLevel) {
      this.selectedLevel = level;
      this.updateSelectedBadge();
      this.updateUserDisplay();
    }
  }

  updateSelectedBadge() {
    const colors = {
      not_evaluated: '#D0D5DD',
      pre_readers: '#F97066',
      beginners: '#FEC84B',
      intermediary: '#6CE9A6',
      fluent: '#45B8FF',
    };

    const badges = this.element.querySelectorAll('[data-level]');
    badges.forEach((badge) => {
      const innerBadge = badge.querySelector('div');
      if (!innerBadge) return;

      const isSelected = badge.dataset.level === this.selectedLevel;

      if (isSelected) {
        innerBadge.style.backgroundColor = colors[badge.dataset.level] || '#FEC84B';
        innerBadge.classList.add('tw-text-coolGray-950', 'tw-border-0');
        innerBadge.classList.remove('tw-border-coolGray-400');
      } else {
        innerBadge.style.backgroundColor = '';
        innerBadge.classList.remove('tw-text-coolGray-950', 'tw-border-0');
        innerBadge.classList.add('tw-border-coolGray-400');
      }
    });
  }

  updateUserDisplay() {
    // Oculta todos os containers de nível
    const allContainers = this.userContainerTarget.querySelectorAll('[data-level-container]');
    allContainers.forEach((container) => {
      container.classList.add('tw-hidden');
    });

    // Mostra o container do nível selecionado
    const selectedContainer = this.userContainerTarget.querySelector(
      `[data-level-container="${this.selectedLevel}"]`,
    );
    if (selectedContainer) {
      selectedContainer.classList.remove('tw-hidden');
    }

    // Calcula o total de alunos
    const totalStudents = this.calculateTotalStudents();

    // Atualiza a contagem de estudantes e a porcentagem
    const selectedStudents = this.getUsersByLevel(this.selectedLevel).length;
    const percentage = totalStudents > 0 ? Math.round((selectedStudents / totalStudents) * 100) : 0;

    if (this.hasStudentCountTarget) {
      this.studentCountTarget.textContent = `${selectedStudents} alunos (${percentage}%)`;
    }
  }

  calculateTotalStudents() {
    // Soma todos os estudantes de todos os níveis
    return (
      this.preReadersValue.length +
      this.beginnersValue.length +
      this.intermediaryValue.length +
      this.fluentValue.length +
      this.notEvaluatedValue.length
    );
  }

  getUsersByLevel(level) {
    let data;
    switch (level) {
      case 'pre_readers':
        data = this.preReadersValue;
        break;
      case 'beginners':
        data = this.beginnersValue;
        break;
      case 'intermediary':
        data = this.intermediaryValue;
        break;
      case 'fluent':
        data = this.fluentValue;
        break;
      case 'not_evaluated':
        data = this.notEvaluatedValue;
        break;
      default:
        data = this.intermediaryValue;
    }

    // Parse JSON string to array if needed
    if (typeof data === 'string') {
      try {
        return JSON.parse(data);
      } catch (e) {
        return [];
      }
    }

    return data;
  }
}
